// Full-document render of the tempurpedic ContactFormPage FORM state:
// PageSkeleton (the React document shell, normal site chrome) wrapping
// ContactFormPageBody.
import React from "react";

import { templates } from "@reactivated";

import { ContactFormPageBody } from "../components/ContactFormPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton). The body accepts Immutable props, to which these are
// assignable.
type IProps = templates.ContactFormPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* React 19 hoists this into <head>. */}
            <meta name="chatTags" content="contact" />
            <ContactFormPageBody {...props} />
        </PageSkeleton>
    );
};
